import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/learning-budgets/')({
  component: () => <Navigate to="/learning-budgets/transactions" />,
});
